/* Global outline color override - uses Colors.bubbleColor (#3f7b8d) */
* {
  outline-color: #3f7b8d !important;
}

*:focus {
  outline-color: #3f7b8d !important;
}

input:focus,
textarea:focus,
select:focus,
button:focus {
  outline-color: #3f7b8d !important;
}

/* Exercise notes textarea placeholder color */
.exercise-notes-textarea::placeholder {
  color: #9c9c9cff;
  opacity: 1;
}
